import IconTimeline from '@/shared/icons/NewDesign/IconTimeline'
import RetryLeadButton from '../AdditionalSales/bones/RetryLeadButton'
import SalePanels from './SalePanels'
import SaleStatusStep from './SaleStatusStep'
import useSaleStatusPanel from './useSaleStatusPanel'
import {
  SaleCard,
  StatusActions,
  StatusHeader,
  StatusLabel,
  StatusSection,
  StatusTitle,
  StatusTitleIcon,
  Stepper,
} from './styled-components'

interface SaleStatusPanelProps {
  saleType: string
}

const SaleStatusPanel = ({ saleType }: SaleStatusPanelProps) => {
  const { t, data, progress, WaitActions, resources, panelValues, highlightedValues, retry } =
    useSaleStatusPanel(saleType)

  return (
    <SaleCard aria-labelledby='additional-sales-status-title'>
      <StatusSection>
        <StatusHeader>
          <StatusTitle id='additional-sales-status-title'>
            <StatusTitleIcon>
              <IconTimeline size={18} />
            </StatusTitleIcon>
            {t('additionalSales:pulse.sale_status')}
          </StatusTitle>
          {progress.label && (
            <StatusLabel $tone={progress.tone} aria-live='polite'>
              {t(progress.label, progress.labelParams)}
            </StatusLabel>
          )}
        </StatusHeader>
        <Stepper $count={progress.steps.length}>
          {progress.steps.map((step, index) => (
            <SaleStatusStep key={step.key} step={step} first={index === 0} t={t} />
          ))}
        </Stepper>
        {WaitActions && (
          <StatusActions>
            <WaitActions saleType={saleType} data={data} t={t} />
          </StatusActions>
        )}
      </StatusSection>
      <SalePanels
        t={t}
        saleType={saleType}
        resources={resources}
        values={panelValues}
        highlightedValues={highlightedValues}
      />
      <RetryLeadButton
        actionsInProgress={retry.actionsInProgress}
        updateLeadDispatch={retry.updateLeadDispatch}
        saleDataState={data}
        callback={retry.callback}
        saleType={saleType}
        hasBeenRetried={retry.hasBeenRetried}
        creationDate={retry.creationDate}
        hidden={retry.hidden}
      />
    </SaleCard>
  )
}

export default SaleStatusPanel
